import React from 'react';
import * as Styled from '../../Sizes.styles';
export default (function () {
  return /*#__PURE__*/React.createElement(Styled.ResponsiveWrapper, null, /*#__PURE__*/React.createElement(Styled.Table, null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "\xA0"), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "28\""), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "30\""), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "32\""), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "34\""), /*#__PURE__*/React.createElement("th", {
    className: "th"
  }, "36\"")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "32\""), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "32A"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "33\""), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "32B"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "34\""), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "32C"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "34A"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "35\""), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "32D"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "34B"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "36\""), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "32DD"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "34C"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "36A"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "37\""), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "32E"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "34D"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "36B"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "38\""), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "32F"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "34DD"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "36C"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "37A"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "39\""), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "32G"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "34E"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "36D"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "38B"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "40\""), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "34F"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "36DD"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "38C"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "40A")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "41\""), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "34G"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "36E"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "38D"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "40B")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "42\""), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "36F"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "38DD"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "40C")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "43\""), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "36G"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "38E"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "40D")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "44\""), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "38F"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "40DD")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "45\""), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "38G"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "40E")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "46\""), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "40F")), /*#__PURE__*/React.createElement("tr", {
    className: "tr"
  }, /*#__PURE__*/React.createElement("td", {
    className: "td row-title"
  }, "47\""), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "\xA0"), /*#__PURE__*/React.createElement("td", {
    className: "td"
  }, "40G")))));
});